/**
 * BrandMark — design.md § Shapes line 311 brand glyph.
 *
 * "Logo mark is a 18px square with a 4px radius and a radial-gradient 'bite'"
 * The radial-gradient bite creates the distinctive notch — NOT a generic
 * letter-in-square placeholder.
 *
 * Rendered as a CSS pseudo-element (::before) on a container div.
 * The radial gradient creates the "bite" (a dark circle that punches
 * through the cobalt fill, producing the notch shape).
 */

import type { ReactElement } from 'react';

export function BrandMark(): ReactElement {
  return (
    <div
      data-brand-mark
      className="brand-mark"
      aria-hidden
    />
  );
}
